import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './i18n';

import { datadogRum } from '@datadog/browser-rum';

import { APP_CONFIG } from './appConfig';
import applyTenantDocumentEffects from './config/applyTenantDocumentEffects';

applyTenantDocumentEffects();

import.meta.env.MODE !== 'e2e' &&
  datadogRum.init({
    applicationId: 'fdbcbe67-e264-44be-8c23-2849c66c31ec',
    clientToken: 'pub5ff0c452d8226a9ca14628c2cbc05282',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'us3.datadoghq.com',
    service: 'one-dashboard',
    env: APP_CONFIG.environment,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: APP_CONFIG.appVersion,
    sessionSampleRate: Number(APP_CONFIG.datadogRumSessionSampleRate),
    sessionReplaySampleRate: Number(APP_CONFIG.datadogRumSessionReplaySampleRate),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/https:\/\/.*\.culliganiot\.com/],
  });

datadogRum.setGlobalContext({
  culligan_domain_version: __CULLIGAN_DOMAIN_VERSION__,
});

async function withMaybeServiceWorker() {
  if (import.meta.env.MSW_ENABLED === 'false') {
    return;
  }

  const { worker } = await import('./testing/mocks/browser');
  await worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },
    onUnhandledRequest: 'bypass',
  });
}

withMaybeServiceWorker()
  .then(async () => {
    /**
     * This dynamic import is needed in order to prevent any request to fire before the msw worker is started.
     */
    const App = (await import('./App')).default;
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      import.meta.env.MODE === 'testing' ? (
        <App />
      ) : (
        <React.StrictMode>
          <App />
        </React.StrictMode>
      ),
    );
  })
  .catch((error) => {
    console.error('[App] Critical error in withMaybeServiceWorker() promise chain or React rendering:', error);
  });
